import { render, staticRenderFns } from "./NoCorporationView.vue?vue&type=template&id=4e15c266"
import script from "./NoCorporationView.vue?vue&type=script&lang=js"
export * from "./NoCorporationView.vue?vue&type=script&lang=js"
import style0 from "./NoCorporationView.vue?vue&type=style&index=0&id=4e15c266&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports